import maDamagedItemBtn from '@/components/buttons'
import maNavbarCategory from '@/components/navbarCategories'
import updateDamagesBtn from '@/components/button-blue'
import maForm from '@/components/form'
import maInputSurface from '@/components/input/modules/text'
import maDamagesCamera from '../damagesCamera'
import maNavbarStepper from '@/components/navbarStepper'
import { required, minValue } from 'vuelidate/lib/validators'
import { numericInputValidation } from '@/mixins/numericInputValidation'
import {
  ASSETS,
  LEVEL_1,
  AUTRES_GEN,
  AUTRES_VALUE,
  EXT,
  GLASS_SURFACE_LEN,
  GLASS_SURFACE_WID
} from '@/constants'
import maEventBus from '@/components/eventbus/index.js'
import debounce from '@/utils/debounce'
import { apiPatchDamage, apiPostImage } from '@/modules/Damage/services/damages'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetForm } from '@/modules/Damage/services/menus'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORTS_MURS,
  WARRANTY_UPDATE_REPORTS_PROPERTIES,
  WARRANTY_UPDATE_REPORTS_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_ADD_REPORTS,
  WARRANTY_GET_SINISTER_WOLOADER,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_REPORTS_SURFACE,
  WARRANTY_UPDATE_LAST_SELECTED_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_VALUE,
  WARRANTY_UPDATE_DAMAGED_PART_KEY
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

import * as Sentry from '@sentry/vue'

export default {
  name: 'damagesDetails',

  mixins: [flowMixin, userFlowMixin, numericInputValidation],

  data() {
    return {
      dataForms: [],
      activeInput: '',
      activeInputValue: '',
      inputSurfaceData: null,
      inputDescriptionData: null,
      showInputSurface: false,
      damageSurface: null,
      targetCategory: '',
      formKey: 0,
      inputSurfaceValue: 0,
      imageCategoriesEnsemble: [],
      imageCategoriesPres: [],
      inputTextNumberError: false,
      titleError: '',
      reportsQty: null,
      formsDamages: [],
      imgList: [],
      formRegions: [],
      inputTextNrFormError: false,
      inputTextDescriptionFormError: false,
      timer: 0,
      errorDamage: false,
      loading: false,
      spinner: false,
      avoidUpdateFormFields: [
        AUTRES_GEN,
        AUTRES_VALUE,
        GLASS_SURFACE_LEN,
        GLASS_SURFACE_WID
      ],
      imgListNewCamera: [],
      imgNoRequired: false,
      isDisabledBtn: false
    }
  },

  validations: {
    inputSurfaceValue: {
      required,
      minValue: minValue(1)
    },
    inputDescriptionData: {
      required
    }
  },

  components: {
    maDamagedItemBtn,
    maNavbarCategory,
    updateDamagesBtn,
    maForm,
    maInputSurface,
    maDamagesCamera,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantySelectedDamagedParts: 'selectedDamagedParts',
      stateWarrantyCounterMurs: 'counterMurs',
      stateWarrantyDamagedPartKey: 'damagedPartKey',
      stateWarrantyDamagedItemKey: 'damagedItemKey',
      stateWarrantyLastSelctedKey: 'lastSelectedKey',
      stateWarrantyCategoryId: 'categoryId',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral'
    }),

    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    },

    flowName() {
      return this.getUserFlow
    },

    titleCategory() {
      const category = this.getDamagedItem
      const title = category.replace('_', ' ').replace('_', ' ').toLowerCase()
      return title
    },

    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral')
      return this.stateWarrantyDamageTypeLiteral
        ? String(this.stateWarrantyDamageTypeLiteral)
        : titleLocalStorage
    },

    getDamagedItemKey() {
      const damagedItemLocalStorage = localStorage.getItem('damagedItemKey')
      return this.stateWarrantyDamagedItemKey
        ? String(this.stateWarrantyDamagedItemKey)
        : damagedItemLocalStorage
    },

    damagedItemHasLevel2() {
      return this.stateWarrantyDamagedItemKey !== LEVEL_1
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyUpdateReportMurs: WARRANTY_UPDATE_REPORTS_MURS,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutWarrantyUpdateReportProperties: WARRANTY_UPDATE_REPORTS_PROPERTIES,
      mutWarrantyUpdateReportByCategory: WARRANTY_UPDATE_REPORTS_BY_CATEGORY,
      mutWarrantyClearReportByCategory: WARRANTY_CLEAR_REPORT_BY_CATEGORY,
      mutWarrantyAddReport: WARRANTY_ADD_REPORTS,
      mutWarrantyClearSelectedDamagedParts: WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateReportSurface: WARRANTY_UPDATE_REPORTS_SURFACE,
      mutWarrantyUpdateLastSelectedKey: WARRANTY_UPDATE_LAST_SELECTED_KEY,
      mutWarrantyUpdateLastSelectedValue: WARRANTY_UPDATE_LAST_SELECTED_VALUE,
      mutWarrantyUpdateDamagedPartKey: WARRANTY_UPDATE_DAMAGED_PART_KEY
    }),

    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinisterWoLoader: WARRANTY_GET_SINISTER_WOLOADER
    }),

    getForm() {
      this.imageCategoriesEnsemble = []
      this.imageCategoriesPres = []
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReportMurs()
      this.stateWarrantyReport.forEach((reportWarranty) => {
        const warrantyId = this.getWarrantyId
        const report = reportWarranty
        this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
          if (resp.formsUpdated) {
            if (
              this.stateWarrantyForms.length ===
              this.stateWarrantySelectedDamagedParts.length
            ) {
              this.setFormsData()
              this.setSelectedValueInputs()
              this.setImageCategories()
              this.formRegions = []
            }
          }
        })
      })
      this.handleEnableButton()
    },

    validateAllNumericInputs() {
      this.$v.inputDescriptionData.$touch()

      if (!this.$refs.form || !Array.isArray(this.$refs.form)) {
        return true
      }

      let hasNumericErrors = false
      let hasDescriptionError = false

      this.$refs.form.forEach(formComponent => {
        if (!formComponent.$children || !Array.isArray(formComponent.$children)) {
          return
        }

        formComponent.$children.forEach(child => {
          const inputName = child.name
          const componentName = child.$options.name

          if (!this.shouldValidateNumericField(inputName)) {
            if (inputName === AUTRES_VALUE) {
              if (this.$v.inputDescriptionData.$error) {
                hasDescriptionError = true
              }
            }
            return
          }

          let inputValue = null

          if (componentName === 'InputTextMap' || componentName === 'InputTextmapline') {
            inputValue = child.mapValue
          } else if (componentName === 'InputTextNumbers' || componentName === 'InputText') {
            inputValue = child.value || child.internalValue
          } else if (componentName === 'TextNumbers') {
            inputValue = child.inputValue
          } else {
            inputValue = child.mapValue || child.value || child.inputValue || child.internalValue
          }

          if (!this.isValidNumericValue(inputValue)) {
            hasNumericErrors = true
          }
        })
      })

      this.inputTextNrFormError = hasNumericErrors
      this.inputTextDescriptionFormError = hasDescriptionError

      return !hasNumericErrors && !hasDescriptionError
    },

    async handleEnableButton() {
      await this.$nextTick()

      const numericInputsValid = this.validateAllNumericInputs()

      if (numericInputsValid) {
        this.handleSetFormDamage().then(async() => {
          const imagesValidated = this.checkImages()
          this.isDisabledBtn = !imagesValidated
        })
      } else {
        this.isDisabledBtn = true
      }
    },

    handleSetFormDamage: async function() {
      this.formsDamages = []
      this.addAssetDamages()

      if (this.inputSurfaceData) this.addSurfaceInfoToReport()

      this.reportsQty = parseInt(this.stateWarrantyReport.length)
      await this.stateWarrantyReport.forEach((report) => {
        if (report.OLD_PROPERTY_AGE) {
          delete report.OLD_PROPERTY_AGE
        }
        this.imgList = []

        if (this.damagedItemHasLevel2) {
          this.setImageLists(
            this.stateWarrantyDamagedPartKey || this.targetCategory,
            report
          )
        } else {
          this.setImageLists(this.stateWarrantyLastSelctedKey, report)
        }

        const subTypeId = this.stateWarrantySubtypeId
          ? this.stateWarrantySubtypeId
          : localStorage.getItem('warranty_subtype_id')

        let damageBody
        if (this.imgListNewCamera && this.imgListNewCamera.length > 0) {
          damageBody = {
            sinister_id: this.getSinisterId,
            event_id: this.stateWarrantySecondaryId,
            category: this.getWarrantyId,
            subcategory: subTypeId,
            form_info: report,
            images: this.imgListNewCamera
          }
        } else {
          damageBody = {
            sinister_id: this.getSinisterId,
            event_id: this.stateWarrantySecondaryId,
            category: this.getWarrantyId,
            subcategory: subTypeId,
            form_info: report,
            images: this.imgList
          }
        }

        const postBody = {
          lat: this.stateWarrantyCoordinates.lat,
          lon: this.stateWarrantyCoordinates.lng,
          zip_code: this.stateWarrantyZipCode,
          real_estate: this.getPropertyType,
          declarant: this.stateWarrantyResidentType,
          more_than_two_years: this.stateWarrantyMoreThanTwoYears
        }

        damageBody = {
          ...damageBody,
          ...postBody
        }

        const exists = this.formsDamages.some(
          (item) => item.sinister_id === damageBody.sinister_id
        )

        if (!exists) {
          this.formsDamages.push(damageBody)
        }
      })
    },

    concatImageLists(
      reportCategoryTitle,
      imgListCategoryTitle,
      targetImg,
      imgListType
    ) {
      const imgListCategory = targetImg[imgListCategoryTitle]
      const categoryMatches =
        reportCategoryTitle.indexOf(imgListCategory) !== -1
      const imgListHasItems = targetImg[imgListType].length > 0

      if (imgListHasItems && categoryMatches) {
        targetImg[imgListType].forEach((img) => {
          delete img.imgSrc
        })
        this.imgList = this.imgList.concat(targetImg[imgListType])
      }
    },

    setImageLists(keyDamagedPart, report) {
      const reportCategory = report[keyDamagedPart]

      this.imageCategoriesEnsemble.forEach((image) => {
        this.concatImageLists(
          reportCategory,
          'categoryTitleEnsemble',
          image,
          'imageListEnsemble'
        )
      })

      this.imageCategoriesPres.forEach((image) => {
        this.concatImageLists(
          reportCategory,
          'categoryTitlePres',
          image,
          'imageListPres'
        )
      })
    },

    handleNoRequirePhotos() {
      this.imgNoRequired = true
    },

    checkImages() {
      if (!this.addDamagesHasImages ||
        Object.keys(this.imgList)[0] === '0' ||
        this.imgListNewCamera.length > 0
      ) return true

      if (this.imgNoRequired) {
        return true
      }

      const imageTypes = ['inputImgEnsemble', 'inputImgPres']
      const imageListTypes = [
        ...new Set(this.imgList.map((image) => image.imageType))
      ]

      return imageTypes.every(
        (imageType) => imageListTypes.indexOf(imageType) > -1
      )
    },

    handleSendDamages: async function() {
      this.loading = true
      if (this.inputSurfaceData) this.inputSurfaceValidation()
      
      // Usar la nueva validación
      const allInputsValid = this.validateAllNumericInputs()

      if (allInputsValid && !this.inputTextNumberError) {
        if (!this.getSinisterId) {
          const sinisterId = this.getSinisterId
          await this.actWarrantyGetSinisterWoLoader(sinisterId)
        }
        this.handleSetFormDamage().then(async() => {
          const imagesValidated = await this.checkImages()
          if (imagesValidated) {
            if (this.formsDamages.length >= 1) {
              this.reportsQty = this.formsDamages.length

              for (const form of this.formsDamages) {
                await apiPatchDamage(form)
                  .then(() => {
                    this.reportsQty -= 1
                  })
                  .catch((error) => {
                    const context = {
                      component: 'damagesDetails',
                      method: 'handleSendDamages',
                      route: this.$route.path
                    }

                    const tags = prepareErrorForSentry(error, context)

                    this.sendSentryError(
                      `Error sending damage report: ${error.message || 'Unknown error'}`,
                      error.response && error.response.status >= 500 ? 'error' : 'warning',
                      tags,
                      this.getWarrantyId,
                      'handleSendDamages'
                    )

                    this.reportsQty -= 1
                    if (this.timer === 0) {
                      this.timer = 800
                    } else {
                      this.timer += 200
                    }
                    this.setError(error)
                    this.loading = false
                  })
                if (
                  this.inputTextNumberError === false &&
                  this.reportsQty === 0
                ) {
                  this.goToDamagesViewRoute()
                }
              }
            }
          } else {
            this.loading = false
            window.scrollTo(0, 0)
            this.throwNotification(
              this.$t('claim.details.errorImages'),
              this.$t('claim.details.errorImages'),
              'KO'
            )
            const scope = new Sentry.Scope()
            scope.setTag('error.type', 'UncontrolledError')
            scope.setLevel('log')
            scope.setTag('section', 'damageDetails handleSendDamages')
            scope.setContext({
              damagesDetails: imagesValidated
            })
            Sentry.captureException(
              new Error('Error on validated images in damageDetails.js'),
              () => scope
            )
          }
        })
      } else {
        this.loading = false
        window.scrollTo(0, 0)
        if (this.inputTextDescriptionFormError) {
          this.throwNotification(
            this.$t('claim.details.errorMsgGeneral'),
            this.$t('textDescriptionError'),
            'KO'
          )
        } else {
          this.throwNotification(
            this.$t('claim.details.errorMsgGeneral'),
            this.$t('claim.details.errorMsgGeneral'),
            'KO'
          )
        }
      }
    },

    setError(err) {
      const objectErrorDamage = JSON.parse(err.response.config.data)
      const literalDamageError = this.getLiteralDamageError(objectErrorDamage)
      const errs = [400, 500, 404]
      const errCode =
        errs.find((errCode) => err.response.status === errCode) || 404
      const messageNotification =
        this.$t(`notifications.error.${errCode}.title`) +
        ' ' +
        literalDamageError

      const scope = new Sentry.Scope()
      scope.setTag('error.type', 'HttpError')
      scope.setExtra('http.status_code', err.response.status)
      err.response.status >= 500 && err.response.status < 600 ? scope.setLevel('error') : scope.setLevel('warning')
      scope.setTag('section', 'damageDetails setError')
      scope.setContext({
        damagesDetails: err
      })
      Sentry.captureException(new Error('Set error for errorCode'), () => scope)
      setTimeout(() => {
        this.throwNotification(messageNotification, messageNotification, 'KO')
      }, this.timer)
    },

    goToDamagesViewRoute() {
      const damagesViewViewName = 'damages-view'
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.mutWarrantyClearReportByCategory()
      this.mutWarrantyClearReportMurs()
      this.mutWarrantyClearSelectedDamagedParts()
      this.goToView(damagesViewViewName)
    },

    getLiteralDamageError(damageError) {
      const reportErrorAssetDamage = JSON.stringify(
        damageError.form_info.asset_damages
      )
      const damageErrorForm = this.dataForms.find((form) => {
        const formAssetDamages = JSON.stringify(form.form.asset_damages)
        if (reportErrorAssetDamage === formAssetDamages) {
          return form
        }
      })
      const literalDamageError = damageErrorForm.damagedPart.literal
      return literalDamageError
    },

    routeToDamagesTypes(routeName) {
      const damageTypeViewName = routeName
      const damageId = 0
      const propertyType = this.getPropertyType
      this.goToView(damageTypeViewName, { damageId, propertyType })
    },

    inputSurfaceValidation() {
      this.$v.$touch()
      if (this.$v.inputSurfaceValue.$error) {
        maEventBus.$emit('inputTextNumbers:error')
        this.inputTextNumberError = true
        setTimeout(() => {
          this.inputTextNumberError = false
        }, 2000)
      }
    },

    handleFormChange: function(event) {
      this.targetCategory =
        event.categoryTitle.indexOf('MUR') !== -1 ? 'MUR' : event.categoryTitle
      const category = this.targetCategory
      const key = event.inputId
      const value = this.getValue(event.inputVal)
      this.mutWarrantyUpdateReportByCategory({ category, key, value })

      if (!this.isUpdateFormRequired(key)) {
        let report = this.getReport(category)
        if (this.targetCategory === EXT) {
          this.mutWarrantyUpdateReportProperties({ key, value })
          this.mutWarrantyUpdateDamagedPartKey(
            this.getReportPropertyByValue(report, category)
          )
        }

        this.updateFormManually(report)
      }

      this.handleEnableButton()
    },

    getValue(value) {
      if (typeof value !== 'object' && value.indexOf(',') !== -1) {
        return value.replace(',', '.')
      } else {
        return value
      }
    },

    handleNestedComponents: debounce(function(dataActiveInput) {
      this.activeInputValue = dataActiveInput.inputVal
      if (dataActiveInput.inputId === AUTRES_GEN) {
        this.inputDescriptionData = dataActiveInput.inputVal
      }

      if (this.isUpdateFormRequired(dataActiveInput.inputId)) {
        this.updateForm(dataActiveInput)
      }

      this.handleEnableButton()
    }, 250),

    updateForm: function({ inputId, inputVal }) {
      const targetReportCategory =
        this.targetCategory.indexOf('MUR') !== -1 ? 'MUR' : this.targetCategory
      const targetReport = this.getReport(targetReportCategory)
      this.loadForm(targetReport, this.getWarrantyId, targetReportCategory)
    },
    updateFormDataForCategory(targetReportCategory, data) {
      this.dataForms.forEach((form) => {
        if (
          form.damagedPart.damagedPart
            .toUpperCase()
            .indexOf(targetReportCategory.toUpperCase()) !== -1
        ) {
          form.form = data.form
          this.addReportDefaultProperties(targetReportCategory)
          this.addSelectedValuesInput(data.form)
          this.getSurfaceInputData(data.form)
          this.removeUnecesaryCategories()
          return form
        }
      })
    },

    cleanReportParams(report) {
      return Object.keys(report).reduce((acc, key) => {
        const value = report[key]

        if (value === '' || value === null || value === undefined) {
          // No incluir en el objeto final
        } else {
          acc[key] = value
        }

        return acc
      }, {})
    },

    loadForm(report, warrantyId, targetReportCategory) {
      const formInputs = document.querySelectorAll('.warranty__content input')
      formInputs.forEach(function(el) {
        el.disabled = true
      })

      const cleanedReport = this.cleanReportParams(report)

      apiGetForm(cleanedReport, warrantyId)
        .then((data) => {
          this.mutWarrantyClearReportByCategory(targetReportCategory)
          this.$nextTick(() => {
            this.dataForms.forEach((form) => {
              if (
                form.damagedPart.damagedPart
                  .toUpperCase()
                  .indexOf(targetReportCategory.toUpperCase()) !== -1
              ) {
                form.form = data.form
                this.addReportDefaultProperties(targetReportCategory)
                this.addSelectedValuesInput(data.form)
                this.getSurfaceInputData(data.form)
                this.removeUnecesaryCategories()
                return form
              }
            })

            if (targetReportCategory.indexOf('MUR') !== -1) {
              this.mutWarrantyUpdateReportMurs(this.stateWarrantyCounterMurs)
            }

            this.$nextTick(() => {
              this.dataForms.forEach((form) => {
                if (
                  form.damagedPart.damagedPart
                    .toUpperCase()
                    .indexOf(targetReportCategory.toUpperCase()) !== -1
                ) {
                  form.form = data.form
                  this.addReportDefaultProperties(targetReportCategory)
                  this.addSelectedValuesInput(data.form)
                  this.getSurfaceInputData(data.form)
                  this.removeUnecesaryCategories()
                  return form
                }
              })

              if (targetReportCategory.indexOf('MUR') !== -1) {
                this.mutWarrantyUpdateReportMurs(this.stateWarrantyCounterMurs)
              }

              this.$nextTick(() => {
                this.handleUpdateForm()
              })
            })
            this.spinner = false
          })
        })
        .catch((error) => {
          const context = {
            component: 'damagesDetails',
            method: 'loadForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error loading damage form: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'loadForm'
          )
        })
        .finally(() => {
          this.formRegions = []
          formInputs.forEach(function(el) {
            el.disabled = false
          })
        })
    },

    handleUpdateForm: function() {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputVal = this.activeInputValue

        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputVal + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    handleChangeInputSurface: debounce(function(valueSurface) {
      this.inputSurfaceValidation()
      if (!this.$v.$invalid) {
        let value = valueSurface.replace(',', '.')
        this.inputSurfaceValue = value
        this.addSurfaceInfoToReport()
      }
      this.handleEnableButton()
    }, 1000),

    setFormsData: function() {
      this.dataForms = this.stateWarrantyForms
      this.addFormCategoryName()
      this.removeUnecesaryCategories()
    },

    updateFormManually(report) {
      Object.keys(this.dataForms[0].form.regions).forEach((region) => {
        this.dataForms[0].form.regions[region].inputs.forEach((input) => {
          if (
            this.avoidUpdateFormFields.includes(input.name) &&
            !!report[input.name]
          ) {
            input.selectedValue = report[input.name]
          }
        })
      })
    },

    isUpdateFormRequired(inputId) {
      return !this.avoidUpdateFormFields.includes(inputId)
    },

    getReport(targetReportCategory) {
      let targetReport = {}
      this.stateWarrantyReport.forEach((report) => {
        const key = Object.keys(report).find(
          (p) => !!p.includes(targetReportCategory)
        )
        if (
          key === this.stateWarrantyLastSelctedKey ||
          Object.keys(report).some((p) => report[p] === targetReportCategory) ||
          !targetReportCategory
        ) {
          targetReport = report
        }
      })

      return targetReport
    },

    getReportPropertyByValue(report, value) {
      return Object.keys(report).find((p) => report[p] === value)
    },

    setSurfaceData(surfaceInputs) {
      surfaceInputs.forEach((input) => {
        if (input.name === 'ROOM_SURFACE') {
          this.inputSurfaceData = input
        }
        if (input.name === 'SURFACE_EVAL') {
          this.damageSurface = {
            key: input.name,
            value: input.selectedValue
          }
        }
      })
    },

    getSurfaceInputData(form) {
      const surfaceRegion = form.regions.find(
        (region) =>
          region.name.indexOf('SURFACE') !== -1 && region.inputs.length > 0
      )
      if (surfaceRegion) this.formRegions.push(surfaceRegion)

      if (this.formRegions.length > 0 && surfaceRegion) {
        if (!this.inputSurfaceData) {
          this.setSurfaceData(surfaceRegion.inputs)
        }
        this.addSurfaceInfoToReport()
      } else if (this.formRegions.length === 0 && !surfaceRegion) {
        this.inputSurfaceData = null
      }
    },

    addFormCategoryName() {
      this.stateWarrantySelectedDamagedParts.forEach((damagedPart) => {
        if (!this.dataForms.damagedPart) {
          this.dataForms = this.dataForms.map((form) => {
            form.form.regions[0].inputs.forEach((input) => {
              if (input.selectedValue === damagedPart.damagedPart) {
                form = { ...form, damagedPart }
              }
              return input
            })
            return form
          })
        }
      })
    },

    removeUnecesaryCategories() {
      const damagedItemKey = this.getDamagedItemKey

      this.dataForms.forEach((form) => {
        form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
          (input) => {
            return (
              input.name !== ASSETS &&
              input.name !== damagedItemKey &&
              input.type !== 'hidden'
            )
          }
        )

        if (this.damagedItemHasLevel2) {
          form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
            (input) => {
              return input.name !== this.stateWarrantyDamagedPartKey
            }
          )
        }

        this.getSurfaceInputData(form.form)

        return form
      })
    },

    addReportDefaultProperties(valueCategory) {
      const nameDamagedItem = this.getDamagedItemKey
      const nameDamagedPart = this.stateWarrantyDamagedPartKey
      let defaultProperties = {}
      defaultProperties['propertyType'] = this.getPropertyType
      defaultProperties[ASSETS] = this.getDamageType
      if (this.damagedItemHasLevel2) {
        defaultProperties[nameDamagedItem] = this.getDamagedItem
      }
      defaultProperties[nameDamagedPart] = valueCategory
      this.mutWarrantyAddReport(defaultProperties)
    },

    addAssetDamages() {
      this.dataForms.forEach((form) => {
        const key = 'asset_damages'
        const value = form.form.asset_damages
        const category =
          form.damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : form.damagedPart.damagedPart
        this.mutWarrantyUpdateReportByCategory({ category, key, value })
      })
    },

    addSurfaceInfoToReport() {
      let key = this.damageSurface ? this.damageSurface.key : null
      let value = this.damageSurface ? this.damageSurface.value : null
      this.mutWarrantyUpdateReportSurface({ key, value })
      key = this.inputSurfaceData ? this.inputSurfaceData.name : null
      value = this.inputSurfaceValue ? this.inputSurfaceValue : null
      this.mutWarrantyUpdateReportSurface({ key, value })
    },

    handleInputFocus: function() {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    updateQtyMurs() {
      const category = 'MUR'
      const key = 'QUANTITY'
      const value = this.stateWarrantyCounterMurs
      this.mutWarrantyUpdateReportByCategory({ category, key, value })
    },

    addSelectedValuesInput(form) {
      form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            const key = input.name
            const value = input.selectedValue
            const category = this.targetCategory
            this.mutWarrantyUpdateReportByCategory({ category, key, value })
          }
        })
      })
    },

    setSelectedValueInputs: function() {
      let category = ''
      this.dataForms.forEach((formCategory) => {
        if (
          formCategory.damagedPart &&
          formCategory.damagedPart.damagedPart.indexOf('MUR') !== -1
        ) {
          category = 'MUR'
          this.updateQtyMurs()
        } else {
          category = formCategory.damagedPart.damagedPart
        }

        formCategory.form.regions.forEach((region) => {
          region.inputs.forEach((input) => {
            if (input.selectedValue) {
              const key = input.name
              const value = input.selectedValue
              this.mutWarrantyUpdateReportByCategory({ category, key, value })
            }
          })
        })
      })
    },

    setImageCategories() {
      this.stateWarrantySelectedDamagedParts.forEach((damagedPart) => {
        const categoryTitleEnsemble =
          damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : damagedPart.damagedPart
        const imageListEnsemble = []
        this.imageCategoriesEnsemble.push({
          categoryTitleEnsemble,
          imageListEnsemble
        })

        const categoryTitlePres =
          damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : damagedPart.damagedPart
        const imageListPres = []
        this.imageCategoriesPres.push({ categoryTitlePres, imageListPres })
      })
    },

    handleFileChangeEnsemble(event) {
      this.imageCategoriesEnsemble.forEach((imgCategory) => {
        if (
          event.categoryTitle.indexOf(imgCategory.categoryTitleEnsemble) !== -1
        ) {
          imgCategory.imageListEnsemble.push(event.fileData)
        }
      })
      this.handleEnableButton()
    },

    handleFileChangePres(event) {
      this.imageCategoriesPres.forEach((imgCategory) => {
        if (event.categoryTitle.indexOf(imgCategory.categoryTitlePres) !== -1) {
          imgCategory.imageListPres.push(event.fileData)
        }
      })
      this.handleEnableButton()
    },

    imageCategoryEnsemble(category) {
      let list = []
      this.imageCategoriesEnsemble.forEach((image) => {
        if (category.indexOf(image.categoryTitleEnsemble) !== -1) {
          list = image.imageListEnsemble
        }
      })
      return list
    },

    imageCategoryPres(category) {
      let list = []
      this.imageCategoriesPres.forEach((image) => {
        if (category.indexOf(image.categoryTitlePres) !== -1) {
          list = image.imageListPres
        }
      })
      return list
    },

    clearForm: function() {
      this.damage = {}
      this.form = {}
      this.updateForm()
    },

    handleClickPrevRoute() {
      if (!this.damagedItemHasLevel2) {
        this.routeToDamagesTypes('damages-types')
        this.mutWarrantyClearSelectedDamagedParts()
      } else {
        this.routeToDamagesTypes('damaged-parts')
      }
    },

    async handleCameraPhotos(photos) {
      const sinisterId =
        this.stateWarrantySinisterId || sessionStorage.getItem('sinId')

      const photosParsed = photos.map((element, index) => {
        const [, ext] = element.split(';')[0].split('/')

        const imageContent = element.replace(/data:[A-z]*\/[A-z]*;base64,/, '')

        let imgBody = {
          imageName: `CameraFlow_${new Date().getTime() + index}.${ext}`,
          imageType: 'cameraFlow',
          imageContent: imageContent
        }
        return imgBody
      })

      const damagePartsPromises = []

      for (const imgBody of photosParsed) {
        damagePartsPromises.push(apiPostImage(sinisterId, imgBody))
      }

      const damagesImages = await Promise.all(damagePartsPromises).catch((error) => {
        const context = {
          component: 'damagesDetails',
          method: 'handleCameraPhotos',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error uploading camera photos: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'handleCameraPhotos'
        )
      })
      this.imgNoRequired = true
      this.imgListNewCamera = damagesImages
    },

    handleOnShowModalCamera() {
      this.$refs.damagesCamera.showModal()
    },

    getCategoryProperty(report, valueToFind) {
      return Object.keys(report).find((p) => report[p] === valueToFind)
    }
  },

  watch: {
    stateWarrantyCounterMurs(value) {
      this.mutWarrantyUpdateReportMurs(value)
    }
  },

  async mounted() {
    this.notifyAppOfChanges(this)
    await this.getForm()
    maEventBus.$on('inputWarranty:focus', ($event) =>
      this.handleInputFocus($event)
    )
  }
}